import Layout from "global/component/Genericos/Layout/Layout";
import { GlobalContext } from "global/context/Provider";
import camelize from "global/utils/camelize";
import { useContext, useEffect, useState } from "react";
import LogoDim from "_+_Portal/assets/images/generico/LogoDim";
import MiTurnoIcon from "_+_Portal/assets/images/generico/MiTurnoIcon";
import { OtrosTramites } from "_+_Portal/assets/images/generico/OtrosTramites";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { LimpiarSelectGlobal } from "_+_Portal/context/Actions/DropDownFamiliares/selectFamiliares";
import { hideModal, showModal } from "_+_Portal/context/Actions/modal/modal";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import {
  wsGetTurnosConPresenteQr,
  wsGetTurnosPacienteDelDiaQr,
} from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import {
  setTurnosRecepcionados,
  setTurnosRecepcionadosAll,
} from "_+_Portal/_-_Autocheckin/context/action/turnosRecepcionados";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import TildeOk from "../../../assets/images/generico/TildeOk";
import { BtnContainer, ContianerHome, HeaderHomeBar } from "./localStyle";
import { setAvisoAutocheck } from "_+_Portal/_-_Autocheckin/context/action/avisoAutocheck";
import { OrderTurnosLabo } from "../PagesFun";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { useHistory } from "react-router";
import { FaMapMarkerAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import { containerVariants, itemVariants } from "global/utils/btnTransition";
import { wsGetOrdenesDigitalesById } from "_+_Portal/_-_Autocheckin/context/action/ordenesDigitales";
import { showToaster } from "global/context/action/toaster/toaster";
import { wsGetLabOrdenDigital } from "_+_Portal/context/Actions/labOrdenDigital/labOrdenDigital";
import OrdenesDigitalesIcon from "_+_Portal/assets/images/generico/OrdenesDigitalesIcon";
import { getLocalStorage, getSessionStorage } from "global/utils/safeJsonParse";

const Home = ({ setLoading, setPasoSelectFamiliar }) => {
  // -------------------------  context ----------------------------
  const {
    pasoDispatch,
    turnosAutoCheckInDispatch,
    turnosRecepcionadosDispatch,
    turnosSeleccionadosDispatch,
    avisoAutocheckState,
    avisoAutocheckDispatch,
    textosAutoCheckinState,
    puntoControlDispatch,
  } = useContext(AutocheckContext);
  const { authState, toasterDispatch } = useContext(GlobalContext);
  const { modalDispatch, labOrdenDigitalDispatch } = useContext(PortalContext);

  // -------------------------  context ----------------------------

  // -------------------------  useStates ----------------------------
  const [dataLoading, setDataLoading] = useState(true);
  const [ordenesLoading, setOrdenesLoading] = useState(true);
  const [nextStepTo, setNextStepTo] = useState(true);
  const [btnGreen, setBtnGreen] = useState(false);
  let listaTurnosHoy = [];
  // -------------------------  useStates ----------------------------

  // -------------------------  constantes ----------------------------
  const pacienteNombre = authState?.auth?.data?.paciente?.nombre;
  const config = getLocalStorage("config", {});
  let opcAutoCheckInLabo = config?.opcAutoCheckInLabo;
  let portal = config?.portal;

  const filtroHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.orden;
  const minutosToleranciaRecepcion = config?.minutosToleranciaRecepcion;
  const minRecepcionVariosTurnos = config?.minRecepcionVariosTurnos;
  const autorizado = sessionStorage.getItem("claveVerificada");
  const noAsociar = sessionStorage.getItem("dismissOrden");
  // const circuitoInicial = sessionStorage.getItem("circuitoInicial");
  const history = useHistory();
  // -------------------------  constantes ----------------------------

  // -------------------------  funciones ----------------------------

  const nextStepTurnosPacienteDelDia = (isCorrect, turnosList) => {
    listaTurnosHoy = turnosList?.filter((item) => item.presente === false);
    if (isCorrect) {
      // Separamos los turnos ya recepcionados (presente=true) de los pendientes
      // (presente=false). Antes guardábamos toda la lista en "recepcionados", lo
      // que hacía que la pantalla de turnos recepcionados mostrara como ✓ tanto
      // los reales como los pendientes, sin posibilidad de recepcionar los faltantes.
      // Si todavía quedan pendientes, la pantalla de "Turnos recepcionados" se
      // encarga de avisarle al paciente y ofrecerle continuar la recepción.
      const turnosPresentes = turnosList?.filter((t) => t.presente) ?? [];

      setTurnosRecepcionados(turnosPresentes)(turnosRecepcionadosDispatch);

      if (turnosPresentes.length > 0) {
        // Hay al menos un turno ya recepcionado: lo llevamos a la pantalla de
        // "Turnos recepcionados" que muestra los confirmados y, si hay pendientes,
        // dispara el modal "Tenés turnos sin recepcionar" + botón "Recepcionarme".
        // Usamos el componente TurnosRecepcionadosQR aunque haya idTerminal porque
        // es el único que tiene la lógica de aviso de pendientes implementada.
        setNextStepTo("TurnosRecepcionadosQR");
        setBtnGreen(true);
      } else if (opcAutoCheckInLabo) {
        setNextStepTo("SelectorCircuito");
        setBtnGreen(false);
      } else {
        setNextStepTo("TurnosDelDia");
        setBtnGreen(false);
      }
    } else {
      showToaster(
        {
          texto: "Error al obtener turnos del paciente.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
      setNextStepTo("SelectorCircuito");
    }
    setDataLoading(false);

    // Si entra por primera vez le pregunto si quiere asociar
    // en caso de que haya clickeado que no quiere asociar
    // no vuelvo a hacer el get para no volver a preguntar
    if (noAsociar === undefined || noAsociar === null) {
      wsGetOrdenesDigitalesById(nextStepOrdenes);
    } else {
      /*if (listaTurnosHoy?.length > 0 && circuitoInicial === null) {
        setPaso("TurnosDelDia")(pasoDispatch);
      } else {
        setOrdenesLoading(false);
      }*/
      setOrdenesLoading(false);
    }
  };

  const nextStepTurnosConPresente = (isCorrect, data) => {
    // El endpoint conPresente solo indica "tiene al menos un presente hoy" — no
    // distingue entre "todos recepcionados" y "hay mixto". La decisión real de
    // btnGreen y nextStepTo se hace abajo, en nextStepTurnosPacienteDelDia, una
    // vez que tenemos la lista completa de turnos con su flag presente.
    if (isCorrect && data) {
      setOrdenesLoading(false);
    }
    wsGetTurnosPacienteDelDiaQr(nextStepTurnosPacienteDelDia)(
      turnosAutoCheckInDispatch,
    );
  };

  const handleOnclick = () => {
    if (
      nextStepTo === "TurnosRecepcionados" ||
      nextStepTo === "TurnosRecepcionadosQR"
    ) {
      let nextStepPaso = (isCorrect, data) => {
        if (isCorrect && data) {
          const laboConfirmados = obtenerlaboConfirmados(data);
          const laboNoConfirmados = obtenerlaboNoConfirmados(data);
          const laboPresentes = obtenerlaboPresentes(data);
          data = data.filter((e) => e.presente);
          setTurnosRecepcionadosAll(data)(turnosRecepcionadosDispatch);
          if (laboNoConfirmados.length > 0) {
            const idTipoPuntoControl = 15;
            setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
            setPaso("PuntoControl")(pasoDispatch);
          } else {
            if (laboConfirmados.length > 0) {
              setPaso("SelectorCircuito")(pasoDispatch);
            } else {
              if (laboPresentes.length > 0) {
                setPaso("SelectorCircuito")(pasoDispatch);
              } else {
                setPaso(nextStepTo)(pasoDispatch);
              }
            }
          }
        }
      };
      setLoading("Cargando turnos del día...");
      wsGetTurnosPacienteDelDiaQr(nextStepPaso)(turnosAutoCheckInDispatch);
    } else {
      setPaso(nextStepTo)(pasoDispatch);
      setPasoSelectFamiliar(nextStepTo);
    }
  };

  const handlePortal = (path, paso) => {
    if (autorizado) {
      if (paso) {
        setPaso(path)(pasoDispatch);
      } else {
        history.push(path);
      }
    } else {
      modalPedirClave(path, paso);
    }
  };

  const handlePortalATS = (path, paso) => {
    if (paso) {
      setPaso(path)(pasoDispatch);
    } else {
      history.push(path);
    }
  };

  const navigateTo = (path, paso) => {
    if (paso) {
      setPaso(path)(pasoDispatch);
    } else {
      history.push(path);
    }
  };

  const modalPedirClave = (path, paso) => {
    showModal(
      "Genericos/PedirClave/PedirClave",
      {
        dissmiss: () => dismiss(false),
        dniPaciente: authState.auth?.data?.paciente?.nroDocumento,
        navigateTo: () => navigateTo(path, paso),
        obtenerClave: () => modalNewClave(path, paso),
      },
      [],
      "centro",
      true,
    )(modalDispatch);
  };

  const modalOrdenesSinAsociar = () => {
    const ordenesLocal = getSessionStorage("ordenesList");
    if (ordenesLocal && ordenesLocal.length > 0) {
      showModal(
        "Genericos/OrdenSinAsociar/OrdenSinAsociar",
        {
          dissmiss: () => dismiss(true),
          navigateTo: () => handlePortal("OrdenesDigitales", true),
          pedirClave: () => modalPedirClave("OrdenesDigitales", true),
          autorizado: autorizado,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
    }
  };

  const modalEleccionTurnoOrden = () => {
    showModal(
      "Genericos/OrdenTurno/OrdenTurno",
      {
        dissmiss: () => {
          dismiss(true);
          // sessionStorage.setItem("circuitoInicial", true);
        },
        pedirClave: () => handlePortal("OrdenesDigitales", true),
        recepcionarse: () => {
          setPaso("TurnosDelDia")(pasoDispatch);
          // sessionStorage.setItem("circuitoInicial", true);
        },
      },
      [],
      "centro",
      true,
    )(modalDispatch);
  };

  const modalNewClave = (path, paso) => {
    dismiss();
    setTimeout(() => {
      showModal(
        "Auth/CambioPassword/CambioPassword",
        {
          texto: "",
          dissmiss: () => dismiss(),
          pathModal: path,
          pasoModal: paso,
          navigateTo: navigateTo,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
    }, 10);
  };

  const dismiss = (orden) => {
    hideModal()(modalDispatch);
    if (orden) {
      sessionStorage.setItem("dismissOrden", true);
    }
  };

  const turnosOrdenadosFun = (turnosList) => {
    const turnosOrdenados = OrderTurnosLabo(
      turnosList,
      filtroHorario,
      minutosToleranciaRecepcion,
      minRecepcionVariosTurnos,
      true,
    );
    return turnosOrdenados;
  };

  const obtenerlaboConfirmados = (turnosList) => {
    const turnosOrdenados = turnosOrdenadosFun(turnosList);
    const laboConfirmados = turnosOrdenados.filter(
      (turno) =>
        turno.estadoProtocolo > 1 &&
        turno.estadoProtocolo < 4 &&
        turno.type === "laboratorio" &&
        turno.selected,
    );
    return laboConfirmados;
  };

  const obtenerlaboNoConfirmados = (turnosList) => {
    const turnosOrdenados = turnosOrdenadosFun(turnosList);
    const laboNoConfirmados = turnosOrdenados.filter(
      (turno) => turno.estadoProtocolo === 1 && turno.type === "laboratorio",
    );
    return laboNoConfirmados;
  };

  const obtenerlaboPresentes = (turnosList) => {
    const turnosOrdenados = turnosOrdenadosFun(turnosList);
    const laboPresentes = turnosOrdenados.filter(
      (turno) => turno.estadoProtocolo === 4 && turno.type === "laboratorio",
    );
    return laboPresentes;
  };

  const nextStepOrdenes = (isCorrect, data) => {
    if (isCorrect) {
      wsGetLabOrdenDigital((isCorrect, dataLabo) =>
        nextStepLabo(isCorrect, data, dataLabo),
      )(labOrdenDigitalDispatch);
    } else {
      showToaster(
        {
          texto: "Error al obtener ordenes digitales.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
      setOrdenesLoading(false);
    }
  };

  const nextStepLabo = (isCorrect, data, dataLabo) => {
    if (isCorrect) {
      if (dataLabo.length > 0 || data.length > 0) {
        sessionStorage.setItem("getOrdenes", true);
        let noAtendidos = data.filter((item) => item.atendido !== true);
        let noAtendidosLabo = dataLabo.filter(
          (item) => item.idEstado === 3 || item.idEstado === 4,
        );
        let ordenesConcat = [...noAtendidos, ...noAtendidosLabo];
        // Ordena por fecha descendente, soporta ambas variantes del campo (fechaAlta y fechaalta)
        let ordenByFecha = ordenesConcat.sort((a, b) => {
          const fechaA = a.fechaAlta || a.fechaalta;
          const fechaB = b.fechaAlta || b.fechaalta;
          return new Date(fechaB).getTime() - new Date(fechaA).getTime();
        });
        setOrdenesLoading(false);
        sessionStorage.setItem("ordenesList", JSON.stringify(ordenByFecha));

        if (listaTurnosHoy.length > 0) {
          modalEleccionTurnoOrden();
        } else {
          modalOrdenesSinAsociar();
        }
      } else {
        sessionStorage.setItem("dismissOrden", true);
        setOrdenesLoading(false);
        // if (listaTurnosHoy.length > 0) {
        //   setPaso("TurnosDelDia")(pasoDispatch);
        //   sessionStorage.setItem("circuitoInicial", true);
        // }
      }
    } else {
      setOrdenesLoading(false);
      showToaster(
        {
          texto: "Error al obtener ordenes de laboratorio.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };
  // // -------------------------  funciones ----------------------------

  // // -------------------------  useEffect ----------------------------
  useEffect(() => {
    let redirigirRecepcion = sessionStorage.getItem("redirigirRecepcion");
    let buscarTurno = sessionStorage.getItem("buscarTurno");
    if (redirigirRecepcion !== null) {
      sessionStorage.removeItem("redirigirRecepcion");
      setPaso("TurnosDelDia")(pasoDispatch);
      return;
    }
    if (buscarTurno !== null) {
      sessionStorage.removeItem("buscarTurno");
      setPaso("NecesitoTurno")(pasoDispatch);
      return;
    }
    let turnoLabo = sessionStorage.getItem("accionLabo");
    if (turnoLabo !== null && turnoLabo !== undefined) {
      sessionStorage.removeItem("accionLabo");
      setPaso("EstudiosLabo")(pasoDispatch);
    } else {
      wsGetTurnosConPresenteQr(nextStepTurnosConPresente)(
        turnosAutoCheckInDispatch,
      );
      setTurnosSeleccionado([])(turnosSeleccionadosDispatch);
    }
  }, []);

  useEffect(() => {
    if (avisoAutocheckState.avisoAutocheck?.show) {
      showModal(
        "Genericos/AvisoAutocheck/AvisoAutocheck",
        { aceptar: aceptarTiempoExtra, disableback: true },
        [],
        "centro",
        true,
      )(modalDispatch);
    }
  }, [avisoAutocheckState.avisoAutocheck?.show]);

  // // -------------------------  useEffect ----------------------------

  const aceptarTiempoExtra = () => {
    setAvisoAutocheck(false)(avisoAutocheckDispatch);
    hideModal()(modalDispatch);
  };

  return (
    <>
      <Loading
        dataLoading={dataLoading || ordenesLoading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      {dataLoading ? (
        ""
      ) : (
        <Layout>
          <ContianerHome
            initial="hidden"
            animate="show"
            variants={containerVariants}
          >
            <HeaderHomeBar
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 1.5,
                ease: "easeInOut",
                opacity: [0, 0.3, 0.7, 1],
                times: [0, 0.3, 0.7, 1],
              }}
            >
              <span className="title">
                ¡Hola{" "}
                <span className="title-negrita">
                  {pacienteNombre && camelize(pacienteNombre)}
                </span>
                !{" "}
              </span>
              <span className="title-pregunta">
                ¿En que podemos ayudarte{" "}
                <span className="title-negrita">hoy</span>?
              </span>
            </HeaderHomeBar>
            <BtnContainer>
              {btnGreen ? (
                <motion.div variants={itemVariants}>
                  <BtnLink
                    Icon={<TildeOk color={"var(--color-primary)"} />}
                    type={"GREEN"}
                    title={"YA RECEPCIONADOS"}
                    onclick={handleOnclick}
                  />
                </motion.div>
              ) : (
                <motion.div variants={itemVariants}>
                  <BtnLink
                    Icon={<TildeOk color={"var(--color-primary)"} />}
                    type={"NORMAL"}
                    title={"TENGO TURNO"}
                    onclick={handleOnclick}
                  />
                </motion.div>
              )}
              <motion.div variants={itemVariants}>
                <BtnLink
                  Icon={<MiTurnoIcon color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"NECESITO UN TURNO"}
                  onclick={() => navigateTo("NecesitoTurno", true)}
                />
              </motion.div>
              <motion.div variants={itemVariants}>
                <BtnLink
                  Icon={<FaMapMarkerAlt color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"ATENCIÓN SIN TURNO"}
                  onclick={() => handlePortalATS("DemandaEspontanea", true)}
                />
              </motion.div>
              <motion.div variants={itemVariants}>
                <BtnLink
                  Icon={<OtrosTramites color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"ÓRDENES PENDIENTES"}
                  onclick={() => handlePortal("OrdenesDigitales", true)}
                />
              </motion.div>
              <motion.div variants={itemVariants}>
                <BtnLink
                  Icon={<OrdenesDigitalesIcon color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"PRÓXIMOS TURNOS"}
                  onclick={() => handlePortal("proximosTurnos", false)}
                />
              </motion.div>
            </BtnContainer>

            {portal && portal === "dim" ? (
              <div className="logo-dim">
                <LogoDim height={"550"} />
              </div>
            ) : (
              ""
            )}
          </ContianerHome>
        </Layout>
      )}
    </>
  );
};

export default Home;
